import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class IdleService implements OnDestroy {
  public subjectIdle = new Subject<boolean>();
  public idle$ = this.subjectIdle.asObservable();
  private idleFrameMs: number;
  private idleTimeout = 0;
  private checkIntervalMs;
  private interval: ReturnType<typeof setInterval>;

  init(idleFrameSeconds: number) {
    this.idleFrameMs = idleFrameSeconds ? idleFrameSeconds * 1000 : 4 * 60 * 60 * 1000;
    this.checkIntervalMs = 900;
    this.restart();
  }

  restart() {
    this.stopTimer();
    this.moveTimeout();
    this.startTimer();
    this.subjectIdle.next(false);
  }

  moveTimeout() {
    const newTimeout = Date.now() + this.idleFrameMs;
    this.setTimeout(newTimeout);
  }

  setTimeout(newTimeout: number): number {
    if (newTimeout > this.idleTimeout) {
      this.idleTimeout = newTimeout;
    }
    return this.idleTimeout;
  }

  protected checkIdle() {
    if (this.isExpired(this.idleTimeout)) {
      this.openAlert();
    }
  }

  protected isExpired(timeout: number): boolean {
    return Date.now() >= timeout;
  }

  protected openAlert() {
    this.stopTimer();
    this.subjectIdle.next(true);
  }

  private startTimer() {
    this.interval = setInterval(() => this.checkIdle(), this.checkIntervalMs);
  }

  private stopTimer() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  ngOnDestroy() {
    this.stopTimer();
  }
}
